import { Box, Stack, Loader } from 'braid-design-system';

const DancingDots = () => (
  <Stack space="none" align="center">
    <Box padding="large">
      <Loader delayVisibility={true} />
    </Box>
  </Stack>
);

export default DancingDots;
